import { IconTemplate } from '@components/Icon/IconTemplate';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Contact = styled.div`
    padding: ${rem(20)} 0;
    font-size: ${({ theme }) => theme.fontSizes.h6};

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
        justify-content: space-between;
    }
`;

export const Company = styled.div`
    padding: 0 ${rem(20)} ${rem(20)} 0;

    @media (min-width: ${breakpoints.md}px) {
        min-width: 35%;
    }
`;

export const CompanyLabel = styled.span<{ $marginTop?: number; $isBold?: boolean }>`
    display: block;
    padding-bottom: ${rem(8)};
    line-height: ${rem(24)};
    color: ${({ theme }) => theme.colors.grey};
    ${(prop) => (prop.$marginTop ? `margin-top: ${rem(prop.$marginTop)}` : '')};
    ${(prop) => (prop.$isBold ? `font-weight: ${prop.theme.fontWeights.textBold}` : '')};
`;

export const Map = styled.div`
    width: 100%;

    iframe {
        border-radius: ${rem(16)};

        @media (min-width: ${breakpoints.sm}px) {
            min-height: ${rem(500)};
        }
    }
`;

export const Gallery = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(30)};
    margin-top: ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
        justify-content: space-between;
        margin-right: ${rem(20)};
    }
`;

export const Image = styled.img`
    border-radius: ${rem(24)};

    @media (min-width: ${breakpoints.sm}px) {
        width: 50%;
    }
`;

export const ContactMap = styled.div``;
